// src/components/MapOperatingAoiPicker.jsx
//
// The map's binding for OperatingAoiPicker.
//
// The picker itself is now controlled — value/onChange — because WellFinder
// Review needs one too and the two must not share state. Everything that used
// to live inside it and is specific to the MAP lives here instead:
//
//   * the useOperatingAoiContext binding, which is a global singleton read by
//     PanelHeader, AoisTab, MyLayersTab, MapView, WellLayer and a dozen others;
//   * the imagery catalog reload, which belongs to the map and would be a
//     pointless fetch anywhere else.
//
// THE LIST COMES FROM THE CONTEXT, NOT FROM A FETCH HERE. useOperatingAoiInit
// already loads /api/v1/operating-aois once at app bootstrap and writes it to
// that store — the picker's own fetch was a second call to the same endpoint
// for the same data, on every mount. Reading the store instead removes it.
import { useEffect } from "react";
import OperatingAoiPicker from "./OperatingAoiPicker";
import { useOperatingAoiContext } from "../stores/useOperatingAoiContext";
import { useImageryStackStore } from "../stores/useImageryStackStore";

export default function MapOperatingAoiPicker() {
  const operatingAois = useOperatingAoiContext((s) => s.operatingAois);
  const activeOperatingAoiId = useOperatingAoiContext((s) => s.activeOperatingAoiId);
  const setActiveOperatingAoiId = useOperatingAoiContext((s) => s.setActiveOperatingAoiId);
  const clearOperatingAoi = useOperatingAoiContext((s) => s.clearOperatingAoi);
  const loadCatalog = useImageryStackStore((s) => s.loadCatalog);

  // Reload the imagery catalog when the active AOI changes. Unchanged in
  // behaviour from the version that lived inside the picker, including firing
  // on mount with whatever the current value is.
  useEffect(() => {
    if (activeOperatingAoiId) loadCatalog({ operatingAoiId: activeOperatingAoiId });
    else loadCatalog();
  }, [activeOperatingAoiId, loadCatalog]);

  return (
    <OperatingAoiPicker
      aois={operatingAois}
      value={activeOperatingAoiId}
      onChange={(id) => (id ? setActiveOperatingAoiId(id) : clearOperatingAoi())}
      allLabel="All Org Assets"
    />
  );
}
